import * as React from "react";
import {connect} from "react-redux";
import TextAreaAutosize from "react-autosize-textarea";
import AppUtils from "../utils/AppUtils";
import {AppMessages} from "../utils/AppConstants";
import {OngoingConsultationActions} from "../actions/OngoingConsultationActions";
import {Tracker} from "../utils/Tracker";
import {EventNames, SectionContext} from "../utils/EventTrackerConstants";

/**
 * Created by Rishabh Kumar 18/02/2019
 */

export interface TextAreaAutoResizeProps {
    name: string
    className?: string
    value: string
    placeholder?: string
    onChange: (event: React.SyntheticEvent<HTMLTextAreaElement>) => void
    rows?: number
    orionClientLogger?: (err: any) => Promise<any>
    disabled?: boolean
    getClassName?: string
    isViewOnly?: boolean
    label?: string
    keyStrokeEvent?: boolean
    widgetName?: string
}

export interface TDispatchProps {
    orionClientLogger: (err: any) => void
}


interface TextAreaAutoResizeState {
    noOfStroke: number
}

class TextAreaAutoResize extends React.Component<TextAreaAutoResizeProps & TDispatchProps, TextAreaAutoResizeState> {

    constructor(props: TextAreaAutoResizeProps & TDispatchProps) {
        super(props);
        this.state = {
            noOfStroke: 0
        }
    }

    static defaultProps: Partial<TextAreaAutoResizeProps> = {
        keyStrokeEvent: true
    }

    static contextType = SectionContext; // registering context type

    handleOnChange = (event: any) => {
        this.logError(event.target.value);
        event.target.value = AppUtils.getNonSpecialCharString(event.target.value);
        if (AppUtils.isDefined(this.props.onChange)) this.props.onChange(event);
    };

    logError = (value: any) => {
        if (AppUtils.isDefined(value) && !AppUtils.containsOnlyAsciiChar(value)) {
            this.props.orionClientLogger({
                message: AppMessages.ERROR_SPECIAL_CHARACTERS,
                value,
                id: this.props.name
            })
        }
    };

    onBlur = (event: any) => {
        const noOfStroke = this.state.noOfStroke
        if (this.props.keyStrokeEvent && noOfStroke) {
            const value = event && event.target && event.target.value
            this.setState({ noOfStroke: 0 })
            Tracker.track(EventNames.KeyStroke, { value: value, field: this.props.name, noOfKeystrokes: noOfStroke, widget: this.props.widgetName, section: this.context });
        }
    }

    onKeyDown = () => {
        this.setState({ noOfStroke: this.state.noOfStroke + 1 })
    }

    render() {
        const {className, value, rows, placeholder, disabled} = this.props;
        const hasOnlyAsciiChar = AppUtils.containsOnlyAsciiChar(value);
        // const specialCharacters = !hasOnlyAsciiChar ? AppUtils.getSpecialCharacters(value.toString()) : "";
        const updatedValue = !hasOnlyAsciiChar ? AppUtils.getNonSpecialCharString(value) : value;
        const viewOnlyProps = {
            isViewOnly: this.props.isViewOnly
        }
        return(
            <div className={"text-area-auto-resize-wrapper"}>
                <TextAreaAutosize
                    className={`textarea-input form-control ${className || ""}`}
                    value={updatedValue || ""}
                    placeholder={placeholder || "Additional Comments"}
                    onChange={this.handleOnChange}
                    onBlur={this.onBlur}
                    onKeyDown={this.onKeyDown}
                    rows={rows || 2}
                    disabled={disabled || false}
                    {...viewOnlyProps}
                />
                {
                    // !hasOnlyAsciiChar && <span className={"erroneous-text"}>{AppMessages.ERROR_SPECIAL_CHARACTERS + " " + specialCharacters}</span>
                }
            </div>
        )
    }
}

const mapDispatchToProps = (): TDispatchProps => {
    return {
        orionClientLogger: (err: any): void => {
            return OngoingConsultationActions.clientLogger(err);
        }
    }
};

export default connect<void, TDispatchProps, TextAreaAutoResizeProps>(null, mapDispatchToProps)(TextAreaAutoResize);